export class SearchBarManager {
  private observer: MutationObserver;

  constructor(
    private readonly searchBar: HTMLInputElement,
    private readonly clearButton: HTMLElement
  ) {
    this.initializeListeners();
  }

  private initializeListeners(): void {
    this.searchBar.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.searchBar.addEventListener('focus', this.handleFocus.bind(this));
    this.searchBar.addEventListener('input', this.handleInput.bind(this));
    this.clearButton.addEventListener('click', this.handleClear.bind(this));
    this.checkClearButtonVisibility();
  }

  private handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.searchBar.form?.dispatchEvent(
        new CustomEvent('submit', { bubbles: true, cancelable: true })
      );
    }
  }

  private handleFocus(): void {
    this.setupMutationObserver();
  }

  private handleInput(): void {
    this.updateClearButtonVisibility();
    this.searchBar.dispatchEvent(
      new CustomEvent('search', { detail: this.searchBar.value })
    );
  }

  private handleClear(): void {
    this.searchBar.value = '';
    this.updateClearButtonVisibility();
    this.searchBar.dispatchEvent(new CustomEvent('search', { detail: '' }));
  }

  private updateClearButtonVisibility(): void {
    this.clearButton.style.display = this.searchBar.value.length > 0 ? 'block' : 'none';
  }

  private checkClearButtonVisibility(): void {
    this.clearButton.style.display = this.searchBar.value.length > 0 ? 'block' : 'none';
  }

  private setupMutationObserver(): void {
    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new MutationObserver(() => {
      const textLength = this.searchBar.value.length;
      this.searchBar.focus();
      this.searchBar.setSelectionRange(textLength, textLength);
    });

    this.observer.observe(document.getElementById("assign-to-organization-modal"), {childList: true});
  }
}
